import React from "react";
import { Typography } from "@material-ui/core";
import useNotesContext from "../../../hooks/useNotesContext";
import { useStyles } from "./PinnedNotes.styles";


const PinnedNote = () => {
  const classes = useStyles();
  const { notes } = useNotesContext();
  const pinnedNote = notes.find((n) => n.pinned);

  if (!pinnedNote) return null;

  return (
    <div className={classes.container}>
      <Typography variant="body1" className={classes.header}>
          Note
      </Typography>
      <div className={classes.root} data-testid="pinned-note">
        
        <Typography variant="body2"className={classes.text}>
          {pinnedNote.noteText}
        </Typography>
      </div>
    </div>
  );
};

export default PinnedNote;
